import { createSelector } from 'reselect'

const getReleases = (state) => state.releases.releases
const getPage = (state) => state.releases.page
const getTotalItemsCount = (state) => state.releases.totalItemsCount
const getAuthLoading = (state) => state.authentication?.loading || false
const getIsListView = (state) => state.setting.listView
const getScrollPosition = (state) => state.releases.scrollPosition

export const releasesSelector = createSelector(
  [
    getReleases,
    getPage,
    getTotalItemsCount,
    getAuthLoading,
    getIsListView,
    getScrollPosition
  ],
  (
    releases,
    page,
    totalItemsCount,
    authLoading,
    isListView,
    scrollPosition
  ) => ({
    releases,
    page,
    totalItemsCount,
    authLoading,
    isListView,
    scrollPosition
  })
)
